var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accessRight)?_c('b-button',{staticClass:"my-3 align-self-center FITButton pointer",attrs:{"size":_vm.size,"variant":_vm.variant,"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.faIcon)?_c('i',{staticClass:"fa pr-1",class:_vm.faIcon}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4dd4c1","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button/FITButton.vue
// module id = null
// module chunks = 